__turbopack_context__.v({
  "changePhoto": "_7Iegza_changePhoto",
  "emptyResponse": "_7Iegza_emptyResponse",
  "endpointOption": "_7Iegza_endpointOption",
  "endpointOptions": "_7Iegza_endpointOptions",
  "fieldLabel": "_7Iegza_fieldLabel",
  "homepageStudio": "_7Iegza_homepageStudio",
  "playground": "_7Iegza_playground",
  "requestEndpoint": "_7Iegza_requestEndpoint",
  "requestPane": "_7Iegza_requestPane",
  "responseHeader": "_7Iegza_responseHeader",
  "responsePane": "_7Iegza_responsePane",
  "samplePortrait": "_7Iegza_samplePortrait",
  "samplePreview": "_7Iegza_samplePreview",
  "sourceOption": "_7Iegza_sourceOption",
  "sourceOptions": "_7Iegza_sourceOptions",
  "spinner": "_7Iegza_spinner",
  "studio-spin": "_7Iegza_studio-spin",
  "submitButton": "_7Iegza_submitButton",
  "submitRow": "_7Iegza_submitRow",
  "uploadArea": "_7Iegza_uploadArea",
  "uploadField": "_7Iegza_uploadField",
  "uploadGuidance": "_7Iegza_uploadGuidance",
  "uploadPreview": "_7Iegza_uploadPreview",
  "uploadPreviewImage": "_7Iegza_uploadPreviewImage",
  "uploadTrigger": "_7Iegza_uploadTrigger",
  "uploads": "_7Iegza_uploads",
});
